export const PERCENTAGE_REGEX = /[1-9][,|.]?[0-9]?$|^100$/
